import Input from "components/Input/index";
import Modal from "components/Models/index";
import "./rename.scss";
import useScreenMobile from "hooks/useScreen";
import Drawer from "components/Drawer/index";

const RenameFile = ({
  submitBtnText = "Rename",
  closeBtnTxt = "Cancel",
  placeholder,
  setMenu,
  menu,
  value,
  onChange,
  label = "",
  handleSave,
  handleCancel,
  heading,
  inputWidth = "93%",
  wrapWidth,
  isVisible,
  width,
  disabled = false,
  maxLength = 80,
  mockClass,
  onKeyDown
  
}) => {
  const isMobile = useScreenMobile({ size: 768 });

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSave();
    }
  };

  return (
    <div className="container renameContainer">
      {isMobile ? (
        <Drawer
          isVisible={menu?.selectedOption === "Rename" || isVisible}
          leftButtonWith="50%"
          rightButtonWith="50%"
          submitBtnText={submitBtnText}
          handleCancel={handleCancel}
          heading={heading}
          showHeader={true}
          handleSave={handleSave}
          showCross={false}
          mockClass={mockClass}
        >
          <Input
            width={inputWidth}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            wrapWidth={wrapWidth}
            label={label}
            maxLength={maxLength}
            mockClass={mockClass}
            autoFocus={true}
            onKeyDown={handleKeyDown} //  Passed down
          />
        </Drawer>
      ) : (
        <Modal
          handleSave={handleSave}
          submitBtnText={submitBtnText}
          closeBtnTxt={closeBtnTxt}
          handleCancel={handleCancel}
          heading={heading}
          showCross={false}
          showHeader={true}
          width={width}
          isDisabled={disabled}
        >
          <Input
            width={inputWidth}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            wrapWidth={wrapWidth}
            label={label}
            maxLength={maxLength}
            mockClass={mockClass}
            autoFocus={true}
           
            
            onKeyDown={handleKeyDown} //  Passed down
          />
        </Modal>
      )}
    </div>
  );
};

export default RenameFile;
